module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Prelims-head",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Also by the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Orange Lilies of Dallington Place")]), _vm._v(" (2018)")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("After The War Comes Love")]), _vm._v(", Volume 1 (2020) ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main _idGenParaOverride-1",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Whisper")]), _vm._v(" (2020)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dd8254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398432048_EPUB1.vue
// module id = 60
// module chunks = 0